import * as React from "react";
import { FaCircle } from "react-icons/fa";

const PricingHero = () => {

  return (
    <>
      <section className="pricing-title">
        <h1 className="first-line">Pricing Plan for Everyone</h1>
        <h2 className="second-line">
          {'Simple '}<FaCircle size={8} color="#ff9e30" />
          {' Transparent '}<FaCircle size={8} color="#ff9e30" />
          {' Meticulously Crafted '}
        </h2>
      </section>
    </>
  );
}

export default PricingHero;
